export const SIZE = {
  MOBILE_WIDTH: 976,
  NEWS_BLOCK_HEIGHT: 96,
  MAX_IMG_FILE_MB: 10,
  MAX_CHAT_IMG_FILE_MB: 15,
  // 업로드 시 리사이즈되는 이미지 한 변의 최대 픽셀. imageResize()가 이 값을 쓴다.
  // (예전엔 utils/media/imageResize.ts가 SIZE를 로컬로 재정의해 2048로 덮어쓰고 있었고,
  //  여기 있던 1024는 아무도 쓰지 않는 값이었다. 실제 동작값인 2048로 통일한다.)
  MAX_IMG_SIZE_PX: 2048,
  MAX_AUDIO_FILE_MB: 10,
  MAX_BG_MUSIC_FILE_MB: 10,
  CONTENTS_WIDTH: 840,
  DEFAULT_ASSET_FETCH_LIMIT: 25, // for default asset scroll pagination
  VIEWER_WIDTH: 450,
  VIEWER_HEIGHT: 800,
  VIEWER_RADIUS: 8,
  STANDARD_BOTTOM_CONTROLLER: 980,
  DEFAULT_LIMIT: 25,
  DEFAULT_WEEKLY_LIMIT: 50,
} as const;

export const IMAGE_MIME = {
  JPEG: 'image/jpeg',
  JPG: 'image/jpg',
  PNG: 'image/png',
  WEBP: 'image/webp',
  GIF: 'image/gif',
  AVIF: 'image/avif',
  JSON: 'application/json',
  LOTTIE: '',
};

export const IMG_TYPE_FOR_CUSTOMER = [
  IMAGE_MIME.AVIF,
  IMAGE_MIME.JPEG,
  IMAGE_MIME.JPG,
  IMAGE_MIME.PNG,
  IMAGE_MIME.WEBP,
];
